import { Typography, Box, Rating } from "@mui/material";
import React from "react";
import { IRateAppointment } from "../interface/iRateAppointment";
import { RateAppointmentContext } from "../context/rateAppointmentContext";
import getStarColor from "../../../../functions/getStarColor";

const labels: { [index: string]: string } = {
  1: "Stimme überhaupt nicht zu",
  2: "Stimme eher nicht zu",
  3: "Neutral",
  4: "Stimme eher zu",
  5: "Stimme voll und ganz zu",
};

const RatingCategory = ({
  index,
  text,
  setRateAppointmentDto,
  rateAppointmentDto,
}: {
  setRateAppointmentDto: React.Dispatch<React.SetStateAction<IRateAppointment>>;
  rateAppointmentDto: IRateAppointment;
  index: number;
  text: string;
}): React.JSX.Element => {
  const {
    isLoading,
  }: {
    isLoading: boolean;
  } = React.useContext(RateAppointmentContext);

  const [hover, setHover] = React.useState(-1);

  // Function to handle the change event of the rating
  const handleOnChange = (
    event: React.ChangeEvent<unknown>,
    newValue: number | null
  ): void => {
    // Prevent the default behavior of the checkbox
    event.preventDefault();

    // Prevent the event from bubbling up to parent elements
    event.stopPropagation();

    // Update the state with the new checked value
    // Create a new array to avoid mutating the original state
    const newStarQuestions = [...rateAppointmentDto.starQestions];

    // Update the specific question's checked value
    // This is done by creating a new object with the updated value and replacing the old object in the array
    // This ensures that React can detect the change and re-render the component when necessary
    newStarQuestions[index].rating = newValue;

    // Update the state with the new array
    setRateAppointmentDto({
      ...rateAppointmentDto,
      starQestions: newStarQuestions,
    });
  };

  return (
    <Box sx={{ my: 4, textAlign: { xs: "center", sm: "left" } }}>
      <Typography variant="body1" color="initial" fontWeight="bold" mb={1}>
        {text}
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: { xs: "center", sm: "flex-start" },
          height: "100%",
          flexWrap: "wrap",
        }}
      >
        <Rating
          disabled={isLoading}
          name="size-large"
          defaultValue={2}
          size="large"
          precision={1}
          value={rateAppointmentDto.starQestions[index].rating}
          onChange={handleOnChange}
          onChangeActive={(_event, newHover) => setHover(newHover)}
          sx={{
            fontSize: "3rem",
            color: getStarColor(
              rateAppointmentDto.starQestions[index].rating || 0
            ),
            "& .MuiRating-iconHover": {
              color: getStarColor(hover),
            },
          }}
        />

        {rateAppointmentDto.starQestions[index].rating !== null && (
          <Box
            sx={{
              ml: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1.2rem",
              height: "100%",
            }}
          >
            {
              labels[
                hover !== -1
                  ? hover
                  : rateAppointmentDto.starQestions[index].rating || 0
              ]
            }
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default RatingCategory;
